<script>

import axios from 'axios';

class ControleMovimentosRepository{
    
    async getControles(token,page){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers:headers});
        return response;

    }

    async createControle(page,rawdata,token){
        
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async  deleteApolice(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async  getControleResumo(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async  getControleMovimentacao(page,token,id) {
        
        const baseURL = (typeof page === 'string' && page.includes('?'))
        ? page
        : `${page}/${id}`;

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async  getEventos(page,token,id) {
        
        const baseURL = (typeof page === 'string' && page.includes('?'))
        ? page
        : `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async  getRegrasAplicadas(page,token,id) {
        
        const baseURL = (typeof page === 'string' && page.includes('?'))
        ? page
        : `${page}/${id}/regras-aplicadas`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async searchApolices(page, token, q) {

        console.log("entrei no seach do repo");
        const baseURL = `${page}/search`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const response = await axios.get(baseURL, {
            headers,
            params: { q }
        });

        return response;
    }

    async fecharControle(token, id) {
        const baseURL = `${process.env.VUE_APP_API_URL}movimentacao/${id}/fechar`;
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.post(baseURL, {}, { headers });
        return response;
    }

    async baixarPreviaCsv(token, controleId) {
        const baseURL = `${process.env.VUE_APP_API_URL}controle/${controleId}/exportar-csv`;
        const headers = {
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL, { 
            headers,
            responseType: 'blob' 
        });
        return response;
    }

    async enviarPreviaEmail(token, controleId) {
        const baseURL = `${process.env.VUE_APP_API_URL}controle/${controleId}/enviar-email-previa`;
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.post(baseURL, {}, { headers });
        return response;
    }

    async cancelarControle(token, id) {
        const baseURL = `${process.env.VUE_APP_API_URL}controle/${id}`;
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL, { headers });
        return response;
    }

    async ajustarMovimentacao(token, id, data) {
        const baseURL = `${process.env.VUE_APP_API_URL}movimentacao-apolice/${id}/ajuste-manual`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.post(baseURL, data, { headers });
        return response;
    }

    async getHistoricoAjustes(token, id) {
        const baseURL = `${process.env.VUE_APP_API_URL}movimentacao-apolice/${id}/ajuste-manual/historico`;
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL, { headers });
        return response;
    }


}

export default ControleMovimentosRepository;
</script>
